import { SVGProps, Ref, forwardRef } from 'react';

export const ConstructionHatOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path d="M11.667 11.93H4.333v-1.4h7.334z" fill="currentColor" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.253 1c1.147 0 1.72 0 2.101.345.234.21.344.506.422.966 3.501.918 4.414 3.883 4.54 8.953.423.401.684.966.684 1.586 0 .894-.56 1.657-1.445 1.788-1.186.174-3.226.36-6.555.36s-5.369-.186-6.555-.36C.561 14.508 0 13.744 0 12.85c0-.62.26-1.186.684-1.587.126-5.07 1.039-8.034 4.539-8.952l-.001.006c.078-.463.19-.76.424-.972.285-.259.68-.323 1.342-.34L7.748 1zm-.506 1.4c-.578 0-.9.003-1.122.028-.047.219-.081.538-.139 1.113l-.48 4.792H4.6l.449-4.5c-.794.3-1.315.742-1.689 1.274-.817 1.164-1.2 3.092-1.277 6.19l-.015.582-.422.4a.8.8 0 0 0-.242.489l-.004.082c0 .156.048.26.091.315a.23.23 0 0 0 .158.088c1.102.162 3.07.344 6.351.344 3.28 0 5.25-.182 6.35-.344a.23.23 0 0 0 .159-.088.46.46 0 0 0 .083-.208l.008-.107a.78.78 0 0 0-.248-.57l-.42-.401-.015-.58c-.077-3.099-.46-5.027-1.277-6.192-.375-.532-.895-.975-1.69-1.276l.45 4.502H9.993l-.48-4.792c-.057-.575-.092-.894-.139-1.113-.223-.025-.544-.028-1.121-.028z"
                fill="currentColor"
            />
        </svg>
    )
);
ConstructionHatOutlinedSize16Glyph.displayName = 'ConstructionHatOutlinedSize16Glyph';
